import React from 'react';
import HeaderContent from './PageElements/HeaderContent';
import { MDBContainer } from 'mdbreact';

function ErrorPage(props){
    return( 
        <>      
         <MDBContainer >
            <HeaderContent isLoggedIn = {props.isLoggedIn}/> 
        <h1>Error Id : {props.errorId}</h1>
        <p>Error Description: {props.errorDesc}</p>
        </MDBContainer>
        </>
    )}

export default ErrorPage;